import { IBookableHours } from '@shared/interfaces/appointment/bookable-hours.interface';

/**
 * Full day slot range of the calendar grid. It is the range FullCalendar is created with and the
 * range the grid has to fall back to whenever bookable hours are not applicable, otherwise a
 * narrowed range stays sticky and hides the appointments outside of it.
 */
export const CALENDAR_SLOT_TIME: IBookableHours = {
  start: '00:00',
  end: '24:00',
};
